import { Box, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { DISPUTE_REASON, type DisputeReason } from "../../../types/createBanDispute.schema";

interface DisputeReasonStepProps {
  selectedReason: DisputeReason | undefined;
  onReasonSelected: (reason: DisputeReason) => void;
  onNextClicked: () => void;
}

function BanDisputeReasonOption({
  reason,
  label,
  isSelected,
}: {
  reason: DisputeReason;
  label: string;
  isSelected: boolean;
}) {
  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${
          isSelected ? theme.palette.border?.primary : theme.palette.border?.subtle
        }`,
        borderRadius: 2,
        padding: 4,
        backgroundColor: isSelected ? theme.palette.background.quaternary : "transparent",
      })}
    >
      <FormControlLabel
        value={reason}
        control={<Radio />}
        label={
          <Text variant="body1" sx={{ marginLeft: 2 }}>
            {label}
          </Text>
        }
        sx={{ margin: 0, width: "100%" }}
      />
    </Box>
  );
}

export function DisputeReasonStep(props: DisputeReasonStepProps) {
  const { selectedReason, onReasonSelected, onNextClicked } = props;

  return (
    <Stack spacing={8}>
      <Text variant="h5">Why would you like to dispute your restriction?</Text>

      <RadioGroup
        value={selectedReason}
        onChange={(event) => {
          onReasonSelected(event.target.value as DisputeReason);
        }}
      >
        <Stack spacing={4}>
          <BanDisputeReasonOption
            reason={DISPUTE_REASON.ATTENDED_INTERVIEW}
            label="I attended my interview"
            isSelected={selectedReason === DISPUTE_REASON.ATTENDED_INTERVIEW}
          />

          <BanDisputeReasonOption
            reason={DISPUTE_REASON.EMERGENCY}
            label="I didn't attend my interview due to an emergency"
            isSelected={selectedReason === DISPUTE_REASON.EMERGENCY}
          />

          <BanDisputeReasonOption
            reason={DISPUTE_REASON.OTHER}
            label="Other"
            isSelected={selectedReason === DISPUTE_REASON.OTHER}
          />
        </Stack>
      </RadioGroup>

      <Button fullWidth disabled={!selectedReason} variant="contained" onClick={onNextClicked}>
        Next
      </Button>
    </Stack>
  );
}
